import { doRequest } from '../../requests/actions';
import { updateFeaturePredicates } from '../features/actions';

export const actions = {
  SET_SETTINGS: 'SETTINGS_ORGANISATION_SET_SETTINGS',
  UPDATE_SETTING: 'SETTINGS_ORGANISATION_UPDATE_SETTING',
  UPDATE_PIN_LENGTH: 'SETTINGS_ORGANISATION_UPDATE_PIN_LENGTH',
  CLEAR: 'SETTINGS_ORGANISATION_CLEAR',
};

export function setSettings(settings) {
  return {
    type: actions.SET_SETTINGS,
    value: settings,
  };
}

export function updateSetting(key, value) {
  return {
    type: actions.UPDATE_SETTING,
    value: {
      key,
      value,
    },
  };
}

export function clear() {
  return {
    type: actions.CLEAR,
  };
}

export function updatePinLength(employees) {
  return {
    type: actions.UPDATE_PIN_LENGTH,
    value: employees,
  };
}

export function getSettings() {
  return async (dispatch) => {
    const settings = await dispatch(doRequest({ endpoint: '/settings' }));
    if (!settings) {
      throw new Error('Failed to retrieve settings');
    }
    dispatch(setSettings(settings));
    dispatch(updateFeaturePredicates());
  };
}

/**
 * TODO: Error Handling
 * Thin wrapper to keep it consistent with the other reducers
 */
export function refresh() {
  return async (dispatch) => {
    try {
      await dispatch(getSettings());
    } catch (e) {
      // ignore this error
    }
  };
}



// WEBPACK FOOTER //
// ./src/store/settings/organisation/actions.js